<template>
    <!-- Note: 这里必须保证 只有 add-container 一个节点 -->
    <add-container
        class="code-list"
        title="条形码"
        :init-item="initCodeItem"
        :item-list="innerData"
        :show-city-list="showCityList"
        :is-required="isRequired"
        :add-btn-disabled="disabled"
        :max-size="100"
    >
        <div slot-scope="scope">
            <xx-form-item
                :label="scope.$index === 0 ? '主条形码' : '条形码'"
                :prop="`skuCodeList.${scope.$index}.code`"
                :rules="rules.code"
                style="margin-bottom: 15px;"
                labelWidth="100px"
            >
                <el-input
                    v-model="scope.item.code"
                    type="number"
                    :disabled="disabled"
                    placeholder="请输入"
                >
                    <xx-select
                        slot="prepend"
                        v-model="scope.item.skuBaseCodeType"
                        style="width: 100px !important"
                        :list="codeTypeOptions"
                        placeholder="请选择"
                        :clearable="false"
                        :disabled="disabled"
                        @change="(val) => { onCodeChange(val, scope.item) }"
                    />
                </el-input>
            </xx-form-item>
            <xx-form-item
                label="产地"
                :prop="`skuCodeList.${scope.$index}.produceAreaId`"
                :rules="rules.produceAreaId"
                style="margin-bottom: 15px;"
                labelWidth="100px"
            >
                <AreaSelect
                    :mode="mode"
                    :area-id="scope.item.produceAreaId || ''"
                    :area-type="scope.item.produceAreaType"
                    :disabled="disabled"
                    @input="(areaId, areaType, index, areaName) => { onAreaInput(areaId, areaType, index, areaName, scope.item) }"
                />
                <FocusTag v-if="focusAttrData.produceArea" />
                <div
                    slot="description"
                    class="title"
                >
                    以商品包装上产地为准，如遇多产地商品，产地选择：中国(详见包装)；进口商品产地=原产地
                </div>
            </xx-form-item>
            <xx-form-item
                label="生产商"
                labelWidth="100px"
            >
                <!-- 品控驳回后允许修改 生产商 白名单 -->
                <ManufactureNameSelectInput
                    :value="getManufactureId(scope.item.manufactureId)"
                    :manufacture-name="scope.item.manufactureName || ''"
                    :show-add-producer="false"
                    :disabled="manufactureIdDisabled"
                    @manufactureIdChanged="(id) => { manufactureIdChanged(id, scope.item) }"
                    @manufactureNameChanged="(name) => { manufactureNameChanged(name, scope.item) }"
                />
                <FocusTag v-if="focusAttrData.manufacturer" />
            </xx-form-item>
        </div>
    </add-container>
</template>

<script>
import Rules, { ValidateRule } from '@lsfe/rules';
import AreaSelect from 'components/AreaSelect';
import ManufactureNameSelectInput from 'components/ManufactureNameSelectInput';
import AddContainer from './addContainer';
import MixinJudgeRejectedAttrsDisabled from '../mixins/rejectedDisabled';
import FocusTag from '../../../../components/FocusTag';

const initCodeItem = (option = {}) => ({
    code: '',
    produceAreaId: '', // 产地
    produceAreaType: '', // 产地类型 没有产地：-1，城市：1，国家或省份：2
    mainCodeFlag: false, // 是否是主条形码
    manufactureId: '', // 生产者ID：更新时如果是新的生产商则传-1
    manufactureName: '',
    // 商品条形码类型, 1 标准条码, 2 自编条码；
    // 标品默认选择准备条码，散装默认选择自编条码
    skuBaseCodeType: '',
    ...option,
});

export default {
    components: {
        AddContainer,
        AreaSelect,
        ManufactureNameSelectInput,
        FocusTag,
    },
    mixins: [MixinJudgeRejectedAttrsDisabled],
    props: {
        isDetail: {
            type: Boolean,
            default: false,
        },
        showCityList: {
            type: Boolean,
            default: true,
        },
        data: {
            type: Array,
            default: () => [],
        },
        categoryId: {
            type: [Number, String],
            default: '',
        },
        bgCategoryId: {
            type: [Number, String],
            default: '',
        },
        // 销售形态：标品1 散装2
        packageType: {
            type: [Number, String],
            default: 1,
        },
        // 是否至少保留一个item，“是”则第一个item没有delete按钮
        isRequired: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        from: {
            type: String,
            default: '',
        },
        // c端展示重点属性
        focusAttrData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            initCodeItem,
            mode: 'edit',
            rules: {
                code: [
                    Rules.isRequired('条形码必填'),
                    Rules.decimalLen({ len: 0 }, '填写整数'),
                    new ValidateRule({
                        validator(rule, data, cb, value) {
                            if (value.skuBaseCodeType === 1 && !(String(value.code).length >= 7 && String(value.code).length <= 14)) {
                                cb(new Error('标准条码长度为7-14位'));
                            } else if (value.skuBaseCodeType === 2 && !(String(value.code).length === 5)) {
                                cb(new Error('自编条码长度为5位'));
                            } else {
                                cb();
                            }
                        },
                    }),
                ],
                produceAreaId: [
                    Rules.isRequired('产地必填'),
                ],
            },
        };
    },
    computed: {
        codeTypeOptions() {
            let options = null;
            if (this.packageType === 1) {
                // 标品，只能存在一个自编条码
                const existedAutoCodeFlag = this.innerData.some((item) => item.skuBaseCodeType === 2);
                options = [
                    {
                        label: '标准条码',
                        value: 1,
                    },
                    {
                        label: '自编条码',
                        value: 2,
                        disabled: existedAutoCodeFlag,
                    },
                ];
            }
            if (this.packageType === 2) {
                options = [
                    {
                        label: '标准条码',
                        value: 1,
                        disabled: true,
                    },
                    {
                        label: '自编条码',
                        value: 2,
                    },
                ];
            }
            return options;
        },
        // 特殊处理生产商的禁用
        // 当在【新品提报】页面被使用时，需要特殊判断 品控驳回白名单的场景：(优先判断：如果是在白名单中，则直接返回false；否则就按照 prop:disabled来返回)
        manufactureIdDisabled() {
            if (this.from === 'createNewProduct' && !this.MixinJudgeRejectedAttrsDisabled('manufacturerId')) {
                return false;
            }
            return this.disabled;
        },
        innerData() {
            return this.data;
        },
    },
    watch: {
        async packageType(newVal) {
            // 切换销售形态，先清空
            this.innerData.splice(0);
            // 标品
            // TODO 如果没有其他逻辑，可以合并
            if (newVal === 1) {
                // 重置一个标准条码
                this.innerData.push(initCodeItem({
                    skuBaseCodeType: 1,
                    mainCodeFlag: true,
                }));
            }
            // 散装
            if (newVal === 2) {
                // 重置成一个自制条码
                this.innerData.push(initCodeItem({
                    skuBaseCodeType: 2,
                    mainCodeFlag: true,
                    code: '',
                }));
                const { validCode } = await this.$service
                    .getOnlyOneValidCode({
                        tSearchValidCodeRequest: {
                            categoryId: this.categoryId,
                            bgCategoryId: this.bgCategoryId,
                        },
                    });
                this.innerData[0].code = validCode;
            }
        },
    },
    methods: {
        onAreaInput(areaId, areaType, index, areaName, item) {
            item.produceAreaId = areaId;
            item.produceAreaName = areaName;
            item.produceAreaType = areaType;
        },
        async onCodeChange(val, item) {
            // 生成自编条码
            if (val === 2) {
                try {
                    const { validCode } = await this.$service
                        .getOnlyOneValidCode({
                            tSearchValidCodeRequest: {
                                categoryId: this.categoryId,
                                bgCategoryId: this.bgCategoryId,
                            },
                        });
                    item.code = validCode;
                } catch (error) {
                    this.$message.error(error.msg || error.message || '获取自编条码失败');
                }
            }
        },
        // 生产商id
        manufactureIdChanged(id, item) {
            item.manufactureId = id;
        },
        // 生产商名称
        manufactureNameChanged(name, item) {
            item.manufactureName = name;
        },
        getManufactureId(val) {
            if (+val <= 0) return '';
            return String(val);
        },
        _validate() {
            let errorMsg = null;
            const codes = this.innerData.map((item) => item.code);
            if (codes.some((code, idx) => codes.indexOf(code) !== idx)) {
                errorMsg = '条形码不能重复';
            }
            if (errorMsg) {
                this.$message.error(errorMsg);
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss" scoped>
.common-row {
    margin-bottom: 15px;
}
.code-list {
    /deep/ .add-item {
        padding-right: 50px !important;
    }
}
</style>
